module.exports = __webpack_public_path__ + "img/button-edit.edafe90d.svg";